import React, { useState, useEffect } from "react";
import config from "lib/config";
import withLanguageContext from "lib/hocs/withLanguageContext";
import Cookies from "js-cookie";
import { ThemeProvider } from "@mui/material/styles";
import theme from "lib/themes/theme";
import Dialog from "Components/Fragment/Dialog";
import Alert from "Components/Fragment/Alert";
import { refreshToken } from "Common/api";

const SESSION_EXPIRATION_MINUTE_THRESHOLD = 5;

const SessionExpiration = ({ languageContext }) => {
  const [open, setOpen] = useState(false);
  const [hasExpired, setHasExpired] = useState(false);

  const oneMinuteTimeout = 60 * 1000;
  useEffect(() => {
    checkSession();
    const intervalId = setInterval(() => {
      checkSession();
    }, oneMinuteTimeout);

    return () => clearInterval(intervalId);
  }, []);

  const checkSession = () => {
    const sessionExpiration = Cookies.get("sessionExpiration");
    if (!sessionExpiration) {
      setHasExpired(true);
      setOpen(true);
      return;
    }

    const expiration = new Date(sessionExpiration);
    const now = new Date();
    const tokenLifeTime = (expiration - now) / 1000;
    const sessionExpirationWarningThreshold =
      SESSION_EXPIRATION_MINUTE_THRESHOLD * 60;
    if (tokenLifeTime < sessionExpirationWarningThreshold) setOpen(true);
    if (tokenLifeTime < 0) setHasExpired(true);
  };

  const refreshSession = () => {
    setOpen(false);
    refreshToken();
  };

  const logOut = () => {
    window.location.href = config.urlRoot + "/logout";
  };

  const sessionExpiresSoonDialog = () => {
    const sessionExpiresSoonDialogTitle = languageContext(
      "yoursessionexpiressoon",
    );
    const sessionExpiresSoonDialogText = languageContext("sessionexpiressoon");

    const confirmText = languageContext("extendsession");
    const cancelText = languageContext("logout");
    return (
      <Dialog
        handleConfirm={refreshSession}
        confirmText={confirmText}
        handleCancel={logOut}
        cancelText={cancelText}
        title={sessionExpiresSoonDialogTitle}
        text={sessionExpiresSoonDialogText}
        open={open}
        showCloseButton={false}
      />
    );
  };

  const sessionHasExpiredAlert = () => {
    const sessionHasExpiredAlertTitle = languageContext(
      "yoursessionhasexpired",
    );
    const sessionHasExpiredAlertText = languageContext("inactivefortoolong");
    const confirmText = languageContext("login");
    return (
      <Alert
        handleConfirm={logOut}
        confirmText={confirmText}
        title={sessionHasExpiredAlertTitle}
        text={sessionHasExpiredAlertText}
        open={open}
      />
    );
  };

  return (
    <ThemeProvider theme={theme}>
      {hasExpired ? sessionHasExpiredAlert() : sessionExpiresSoonDialog()}
    </ThemeProvider>
  );
};

export default withLanguageContext(SessionExpiration, "Login");
